import { useState } from 'react';
import { useBaseViewModel } from '@/common';
import { EmployeeEntity } from '@/domains/employee/entities';
import { UpdateEmployeeBaseIdUsecase } from '@/domains/employee/usecases/update-base-id.usecase';
import { EmployeeHttpRepository } from '../adapters/repositories';
import { notification } from 'antd';

const UpdateBaseIdEmployeeViewModel = () => {
  const { loading, error, setLoading, setError } = useBaseViewModel();
  const [updatedEmployee, setUpdatedEmployee] = useState<EmployeeEntity>();

  const updateBaseIdUsecase = new UpdateEmployeeBaseIdUsecase(new EmployeeHttpRepository());

  // Rejects on failure so the caller can surface the message; catchAction is
  // deliberately not used here because it swallows the error.
  const actionUpdateBaseId = async (employeeCode: string, baseId: string) => {
    try {
      setLoading(true);
      setError(undefined);
      const data = await updateBaseIdUsecase.run({ employeeCode, baseId });
      setUpdatedEmployee(data);
      notification.success({
        message: 'Success',
        description: 'Employee linked to user successfully',
        placement: 'bottomRight',
      });
      return data;
    } catch (err) {
      setError(err as Error);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    updatedEmployee,
    loading,
    error,
    actionUpdateBaseId,
  };
};

export default UpdateBaseIdEmployeeViewModel;
